<template lang="pug">
  .lottery-publicity-card-container
    transition(v-for="(item, index) in numberList")
      CommonCard(
        :key="index"
        :dataForm="item"
      )
</template>

<script>
import CommonCard from './common-card';

export default {
  name: 'LotteryPublicityCard',
  components: {
    CommonCard,
  },
  props: {
    numberList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.lottery-publicity-card-container {
  background-color: #fff;
  border-radius: 0.16rem;
}
</style>
